<div [formGroup]="filtri">
  <div class="flex flex-column align-items-center sm:flex-row mb-5 pt-5">
    <div class="flex align-items-center justify-content-center mb-5 sm:mb-0 gap-3">
      <div class="sm:mr-3">
        <span class="p-input-icon-left p-input-icon-right p-float-label">
          <i class="pi pi-search"></i>
          <input type="text" id="cercaIscritto" class="shadow-4" pInputText formControlName="stringaFiltro" />
          <label for="cercaIscritto">Cerca Utente</label>
          <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
        </span>
      </div>
      <div class="mb-3 sm:mb-0">
        <p-dropdown formControlName="sezione" [showClear]="true" [options]="sezioniDropdown" optionLabel="nome" placeholder="Sezione"></p-dropdown>
      </div>
      <div class="mb-3 sm:mb-0">
        <p-dropdown formControlName="statoIscrizione" [showClear]="true" [options]="statiIscrizioneDropdown" optionLabel="nome" placeholder="Stato Iscrizione"></p-dropdown>
      </div>
      <p-button
        class="clearFiltri"
        size="small"
        [outlined]="true"
        icon="pi pi-filter-slash"
        (click)="clearFilters()"
        [pTooltip]="translate.instant('tooltip.pulisciFiltri')"
        tooltipPosition="right" />
    </div>
  </div>
  <div class="flex justify-content-start mb-5">
    <p-paginator
      [rows]="pageSize"
      [first]="currentPage"
      [rowsPerPageOptions]="[25, 100, 250, 500]"
      (onPageChange)="pageChange($event)"
      [totalRecords]="totaleDati"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} di {totalRecords}"
      [showPageLinks]="false" />
  </div>
</div>
<p-table
  #dt
  [value]="listaIscrizioni"
  [rowHover]="true"
  (onLazyLoad)="ordinamento($event)"
  [customSort]="true"
  [lazy]="true"
  [sortField]="orderColumnName"
  [sortOrder]="orderCustom(order)">
  <ng-template pTemplate="header">
    <tr>
      @for(headerName of headersTabella; track $index){
        <th [pSortableColumn]="headerName">
          {{ headerName }}
          <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-iscrizione>
    <tr style="cursor: pointer;" [routerLink]="'/domande_iscrizione/storico/dettaglio_pratica/' + iscrizione.id">
      @for(rowName of rowsTabella; track $index){
        @if(rowName == "domandaData"){
          <td>{{ iscrizione[rowName] | date: 'dd/MM/yyyy' }}</td>
        }
        @else if(rowName == "statoIscrizione"){
          <td class="font-bold"
            [ngStyle]="{ 'color': statoColori.get(iscrizione.statoIscrizione) }">
            {{ iscrizione[rowName] }}
          </td>
        }
        @else{
          <td>{{ iscrizione[rowName] }}</td>
        }
      }
    </tr>
  </ng-template>
</p-table>